/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Focus_Pass_Iap_Plus_FootnoteInputs */

const en_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock VIP rewards during your Plus subscription.`)
};

const ar_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افتح مكافآت Plus خلال اشتراكك في بلس.`)
};

const de_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schalten Sie während Ihres Plus-Abonnements VIP-Prämien frei.`)
};

const es_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquea recompensas Plus mientras tengas la suscripción Plus.`)
};

const fr_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloquez les récompenses Plus pendant que votre abonnement Forest Plus est actif.`)
};

const it_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca i premi Plus durante il tuo abbonamento Plus.`)
};

const ja_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusサブスクリプション期間中、Plus報酬をアンロックできます。`)
};

const ko_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 구독 기간 중 Plus 리워드를 받으세요.`)
};

const pt_br_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueie recompensas Plus durante sua assinatura Plus.`)
};

const ru_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокируйте Plus-награды с подпиской Plus.`)
};

const th_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกรางวัล Plus ระหว่างการสมัครสมาชิก Plus ของคุณ`)
};

const tr_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus aboneliğin süresince Plus ödüllerinin kilidini aç.`)
};

const zh_cn_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 会员效期内，视为解锁 VIP 通行证领取资格`)
};

const zh_tw_focus_pass_iap_plus_footnote = /** @type {(inputs: Focus_Pass_Iap_Plus_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 訂閱效期內，視為解鎖 VIP 通行證領取資格`)
};

/**
* | output |
* | --- |
* | "Unlock VIP rewards during your Plus subscription." |
*
* @param {Focus_Pass_Iap_Plus_FootnoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const focus_pass_iap_plus_footnote = /** @type {((inputs?: Focus_Pass_Iap_Plus_FootnoteInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Focus_Pass_Iap_Plus_FootnoteInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_focus_pass_iap_plus_footnote(inputs)
	if (locale === "ar") return ar_focus_pass_iap_plus_footnote(inputs)
	if (locale === "de") return de_focus_pass_iap_plus_footnote(inputs)
	if (locale === "es") return es_focus_pass_iap_plus_footnote(inputs)
	if (locale === "fr") return fr_focus_pass_iap_plus_footnote(inputs)
	if (locale === "it") return it_focus_pass_iap_plus_footnote(inputs)
	if (locale === "ja") return ja_focus_pass_iap_plus_footnote(inputs)
	if (locale === "ko") return ko_focus_pass_iap_plus_footnote(inputs)
	if (locale === "pt_br") return pt_br_focus_pass_iap_plus_footnote(inputs)
	if (locale === "ru") return ru_focus_pass_iap_plus_footnote(inputs)
	if (locale === "th") return th_focus_pass_iap_plus_footnote(inputs)
	if (locale === "tr") return tr_focus_pass_iap_plus_footnote(inputs)
	if (locale === "zh_cn") return zh_cn_focus_pass_iap_plus_footnote(inputs)
	return zh_tw_focus_pass_iap_plus_footnote(inputs)
});